import { jsx as _jsx } from "react/jsx-runtime";
import Login from '../pages/authentication/Login';
import ForgotPassword from '../pages/authentication/ForgotPassword';
import GuestGuard from '../components/GuestGuard';
export const DEFAULT_ROUTES = [
    {
        path: 'login',
        element: (_jsx(GuestGuard, { children: _jsx(Login, {}) })),
    },
    {
        path: 'forgot-password',
        element: (_jsx(GuestGuard, { children: _jsx(ForgotPassword, {}) })),
    },
];
//# sourceMappingURL=defaultRoute.js.map